module.exports = __webpack_public_path__ + "img/p2.0c10ac76.png";